class BaseError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = new.target.name;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
export class TokenNotValid extends BaseError {}

export class MissingIntegrationPageSearchParams extends BaseError {}
